import React from 'react';
import { FormattedMessage } from 'react-intl';

import { FlexColumn } from 'ui-components/components/flex';
import { Text, TextType } from 'ui-components/components/text';

import { AmountSummaryLabel } from '../../../fulfillment-plan/sections/shipment-details/amount-summary/read-only/amount-summary-label';
import { emptyObject } from 'ui-components/default-props/empty';
import { ReadOnlyAmountSummary } from '../../../fulfillment-plan/sections/shipment-details/amount-summary/read-only';
import { ReadonlyFulfillmentPlanDate } from '../../../fulfillment-plan/sections/shipment-details/fulfillment-plan-dates/readonly-fulfillment-plan-date';
import { ShipmentDetailsField } from '../../../fulfillment-plan/sections/shipment-details/field';
import { ShipmentDetailsLayoutLoader } from '../../../layouts/shipment-details-layout/shipment-details-layout-loader';
import { ShipToAddress, ShipToLabel } from '../../../fulfillment-plan/sections/shipment-details/address';
import { useEntitiesSalesOrder } from '../../../../../hooks/entities/selectors/sales-orders';
import { useGetAllFulfillmentPlanShipTosAreEqualFromSalesOrder } from '../../../fulfillment-plan/sections/shipment-details/address/use-shipment-details-address';
import { useSalesOrderIdContext } from '../../../../context/sales-order-id-context-provider';

import { messages } from './messages';
import style from './style.module.less';

const OrderDateFieldId = 'order-date';
const PaidDateFieldId = 'paid-date';

export const ShipmentDetailsExpanderContent = () => {
  const salesOrderId = useSalesOrderIdContext();
  const allShipTosEqual = useGetAllFulfillmentPlanShipTosAreEqualFromSalesOrder(salesOrderId);

  const { orderDateTime, paidDateTime, shipTos = [{}], soldTo = {} } = useEntitiesSalesOrder(salesOrderId) || emptyObject;

  const [firstShipTo] = shipTos;
  const recipientInfo = {
    email: '',
    name: '',
    phone: '',
    ...soldTo,
  };

  const addressColumnContent = (
    <ShipmentDetailsField label={<ShipToLabel />}>
      {allShipTosEqual ? (
        <ShipToAddress recipientInfo={recipientInfo} shipTo={firstShipTo} />
      ) : (
        <FlexColumn>
          <Text
            className={style['multi-address-info']}
            textType={TextType.Paragraph}
            value={<FormattedMessage {...messages.multipleShipToAddresses} />}
          />
        </FlexColumn>
      )}
    </ShipmentDetailsField>
  );

  const costSummaryColumnContent = (
    <ShipmentDetailsField label={<AmountSummaryLabel />}>
      <ReadOnlyAmountSummary />
    </ShipmentDetailsField>
  );

  const datesColumnContent = (
    <>
      <ShipmentDetailsField label={<FormattedMessage {...messages.orderDate} />} labelFor={OrderDateFieldId}>
        <ReadonlyFulfillmentPlanDate dateValueUtc={orderDateTime} />
      </ShipmentDetailsField>
      <ShipmentDetailsField label={<FormattedMessage {...messages.paidDate} />} labelFor={PaidDateFieldId}>
        <ReadonlyFulfillmentPlanDate dateValueUtc={paidDateTime} />
      </ShipmentDetailsField>
    </>
  );

  return (
    <ShipmentDetailsLayoutLoader
      addressColumnContent={addressColumnContent}
      costSummaryColumnContent={costSummaryColumnContent}
      datesColumnContent={datesColumnContent}
    />
  );
};
